(function() {
  if (window.customElements.get('fm-scroll-carousel')) return;

  class FMScrollCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.previousButton = this.querySelector('[data-carousel-previous]');
      this.nextButton = this.querySelector('[data-carousel-next]');

      if (!this.track || !this.previousButton || !this.nextButton) return;

      this.previousButton.addEventListener('click', () => this.scroll(-1));
      this.nextButton.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => this.requestStateUpdate(), { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateButtonState());
        this.resizeObserver.observe(this.track);
      }

      this.updateButtonState();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      window.cancelAnimationFrame(this.stateFrame);
    }

    scroll(direction) {
      const item = this.track.querySelector(':scope > *');
      const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      const distance = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      this.track.scrollBy({ left: direction * distance, behavior });
    }

    requestStateUpdate() {
      window.cancelAnimationFrame(this.stateFrame);
      this.stateFrame = window.requestAnimationFrame(() => this.updateButtonState());
    }

    updateButtonState() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const current = Math.abs(this.track.scrollLeft);
      const hasOverflow = maximum > 2;

      this.previousButton.disabled = !hasOverflow || current <= 2;
      this.nextButton.disabled = !hasOverflow || current >= maximum - 2;
      this.toggleAttribute('data-has-overflow', hasOverflow);
    }
  }

  window.customElements.define('fm-scroll-carousel', FMScrollCarousel);
})();
